import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/pics/logo3.png'


const _hoisted_1 = { class: "min-h-screen bg-black text-white p-10" }
const _hoisted_2 = { class: "p-6 flex justify-between items-center" }
const _hoisted_3 = { class: "flex gap-6" }

import Footer from '@/components/Footer.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const navLinks = [
  
  { text: '一对一私人咨询', to: '/vip' }
  // { text: '信号灯（测试）', to: '/signal' }
]

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "Logo",
        class: "h-8 hover:opacity-80 transition-opacity",
        onclick: "window.location.href = '/'"
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navLinks, (link) => {
          return _createVNode(_component_router_link, {
            key: link.to,
            to: link.to,
            class: "text-gray-300 hover:text-white transition-colors"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(link.text), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        }), 64))
      ])
    ]),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        _createVNode(_Transition, {
          name: "fade",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }),
    _createVNode(Footer)
  ]))
}
}

})